// src/pages/CRMContactFormPage.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { companiesAPI } from '../services/api';
import toast from 'react-hot-toast';
import { ArrowLeft, Save } from 'lucide-react';

export default function CRMContactFormPage() {
  const { id }   = useParams();
  const navigate = useNavigate();
  const isEdit   = !!id;
  const [saving, setSaving] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [form, setForm] = useState({
    full_name: '', job_title: '', email: '', phone: '', company_id: '', status: 'INTERLOCUTEUR'
  });

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const res = await companiesAPI.list({});
        setCompanies(res.data || []);
      } catch {}
    };
    fetchCompanies();

    if (!isEdit) return;
    // Assuming getContact exists
    // companiesAPI.getContact(id).then(r => setForm(r.data)).catch(() => { toast.error('Erreur'); navigate('/crm-contacts'); });
  }, [id]);

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.full_name || !form.company_id) { toast.error('Nom et société obligatoires'); return; }
    setSaving(true);
    try {
      if (isEdit) {
        // await companiesAPI.updateContact(id, form);
      } else {
        await companiesAPI.createContact(form.company_id, form);
      }
      toast.success(isEdit ? 'Contact mis à jour' : 'Contact créé');
      navigate(isEdit ? `/crm-contacts/${id}` : '/crm-contacts');
    } catch { toast.error('Erreur sauvegarde'); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div className="page-header">
        <div className="page-header-left" style={{ display:'flex', alignItems:'center', gap:12 }}>
          <button className="btn btn-ghost btn-icon" onClick={() => navigate(isEdit ? `/crm-contacts/${id}` : '/crm-contacts')}><ArrowLeft size={18}/></button>
          <div>
            <h1>{isEdit ? 'Modifier le contact' : 'Nouveau contact'}</h1>
            <p>{isEdit ? form.full_name : 'Ajouter un contact CRM'}</p>
          </div>
        </div>
        <div className="page-header-actions">
          <button className="btn btn-primary" onClick={handleSubmit} disabled={saving}>
            <Save size={16} /> {saving ? 'Sauvegarde...' : 'Sauvegarder'}
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="form-container">
        <div className="form-grid">
          <div className="form-group">
            <label>Nom complet *</label>
            <input type="text" value={form.full_name} onChange={set('full_name')} required />
          </div>
          <div className="form-group">
            <label>Poste</label>
            <input type="text" value={form.job_title} onChange={set('job_title')} />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input type="email" value={form.email} onChange={set('email')} />
          </div>
          <div className="form-group">
            <label>Téléphone</label>
            <input type="tel" value={form.phone} onChange={set('phone')} />
          </div>
          <div className="form-group">
            <label>Société *</label>
            <select value={form.company_id} onChange={set('company_id')} required>
              <option value="">Sélectionner une société</option>
              {companies.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label>Statut</label>
            <select value={form.status} onChange={set('status')}>
              <option value="PROSPECT">Prospect</option>
              <option value="INTERLOCUTEUR">Interlocuteur</option>
              <option value="DECISIONNAIRE">Décisionnaire</option>
              <option value="INACTIF">Inactif</option>
            </select>
          </div>
        </div>
      </form>
    </div>
  );
}